<template>
  <section class="new-table">
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('TABLE', 1) }) | formatTitle"></vue-headful>
    <form class="ui form" autocomplete="off">
      <div class="ui top attached segment">
        <h4 class="ui dividing header">{{ $t('CREATE', { thing: $tc('TABLE', 1) }) }}</h4>
        <div class="field required" :class="{ error: $v.table.name.$error }">
          <label for="tableName">{{ $t('NAME') }}</label>
          <input
            id="tableName"
            type="text"
            :placeholder="$t('NAME')"
            v-model.trim="table.name"
            @click="$v.table.name.$touch()"
          />
        </div>
      </div>
      <div class="ui bottom attached tabular menu" style="padding-top: 8px;">
        <div class="right menu">
          <loading-button class="ui labeled icon button" :onClick="createTable">
            {{ $t('CREATE', { thing: '' }) }}
            <i class="checkmark icon"></i>
          </loading-button>
        </div>
      </div>
    </form>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import Vue from 'vue'
import { Table, Toast } from 'services'
import { LoadingButton } from 'ui'
import { required } from 'vuelidate/lib/validators'

const table = {
  name: '',
  csv: ''
}

export default {
  name: 'new-table',
  components: { LoadingButton },
  data() {
    return {
      table: { ...table },
      savePending: false
    }
  },

  validations: {
    table: {
      name: {
        required
      }
    }
  },

  computed: {
    savesRequested() {
      return this.$store.state.savesRequested
    }
  },

  methods: {
    createTableSafely() {
      if (!this.savePending) this.createTable()
    },
    createTable() {
      if (!this.$v.$invalid) {
        this.savePending = true
        return Table.createTable(this.table)
          .then(res => {
            Toast.success(this.$i18n.t('CREATED', { thing: this.$i18n.tc('TABLE', 1) }), {
              remove: 5000
            })
            this.$router.push({
              name: 'table-home',
              params: { tableId: res.id }
            })
          })
          .catch(err => {
            Toast.error(
              this.$i18n.t('ERR', {
                action: this.$i18n.t('CREATE', { thing: this.$i18n.tc('TABLE', 1) })
              })
            )
            console.error(err)
          })
          .finally(() => {
            this.savePending = false
          })
      } else {
        this.$v.$touch()
        Toast.warning(
          this.$i18n.t('WARN_REQUIRED', {
            action: this.$i18n.t('CREATE', { thing: this.$i18n.tc('TABLE', 1) }),
            thing: this.$i18n.t('ALL_REQUIRED_FIELDS')
          })
        )
        return Promise.reject('Required fields missing')
      }
    }
  },

  watch: {
    savesRequested() {
      this.createTableSafely()
    }
  }
}
</script>
